import React from "react";
import RegularGreyText from "./RegularGreyText";
import ActionButton from "./ActionButton";

export default function ActionMessageButton({
  buttonTextSize = "",
  text,
  buttonText,
  buttonClick,
  disabled,
  messageTextSize = "1.3vmin",
  lineheight,
  textDisplay = "flex",
  buttonHeight = "33%",
  id,
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div
        style={{
          width: "100%",
          height: "67%",
          display: textDisplay,
          alignItems: "flex-end",
          marginBottom: 10,
        }}
      >
        <RegularGreyText
          text={text}
          fontSize={messageTextSize}
          lineheight={lineheight}
        ></RegularGreyText>
      </div>
      <div style={{ width: "100%", height: buttonHeight }}>
        <ActionButton
          text={buttonText}
          onClick={buttonClick}
          fontSize={buttonTextSize}
          disabled={disabled}
          id={id}
        ></ActionButton>
      </div>
    </div>
  );
}
